// assets
import GroupIcon from '@mui/icons-material/Group';
import CloudIcon from '@mui/icons-material/Cloud';
import SecurityIcon from '@mui/icons-material/Security';
import EngineeringIcon from '@mui/icons-material/Engineering';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import BallotIcon from '@mui/icons-material/Ballot';
import LaptopIcon from '@mui/icons-material/Laptop';
import EmailIcon from '@mui/icons-material/Email';

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const admin = {
  id: 'sample-docs-roadmap',
  title: 'Administración',
  type: 'group',
  children: [
    {
      id: 'dependencies-management',
      title: 'Gestión Instituciones',
      type: 'item',
      url: '/dependencies-management',
      icon: AccountBalanceIcon,
      breadcrumbs: false
    },
    {
      id: 'providers-management',
      title: 'Gestión de Proveedores',
      type: 'item',
      url: '/providers-management',
      icon: BallotIcon,
      breadcrumbs: false
    },
    {
      id: 'notifications-management',
      title: 'Gestión de Notificaciones',
      type: 'item',
      url: '/notifications-management',
      icon: EmailIcon,
      breadcrumbs: false
    },
    {
      id: 'users-management',
      title: 'Gestión Usuarios',
      type: 'item',
      url: '/users-management',
      icon: GroupIcon,
      breadcrumbs: false
    },
    {
      id: 'divider',
      type: 'divider',
      breadcrumbs: false
    },
    {
      id: 'google-cloud',
      title: 'Google Cloud',
      type: 'item',
      url: '/google-cloud',
      icon: CloudIcon,
      breadcrumbs: false
    },
    {
      id: 'hardware',
      title: 'Hardware',
      type: 'item',
      url: '/hardware',
      icon: LaptopIcon,
      breadcrumbs: false
    },
    {
      id: 'cybersecurity',
      title: 'Ciberseguridad',
      type: 'item',
      url: '/cybersecurity',
      icon: SecurityIcon,
      breadcrumbs: false
    },
    {
      id: 'professional-works',
      title: 'Servicios Profesionales',
      type: 'item',
      url: '/professional-works',
      icon: EngineeringIcon,
      breadcrumbs: false
    }
  ]
};

export default admin;
